import React, { Component } from 'react';
import { ConfirmationModal } from './ConfirmationModal';

export class Layout extends Component {
  static displayName = Layout.name;

  render () {
    return (
      <>
        <main id="main-content" tabIndex="-1">
            {this.props.children}
            <ConfirmationModal />
        </main>
      </>
    );
  }
}
